// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"18":"0c3517b9","286":"f076bc35","392":"623d151e","529":"a12aacfb","640":"057ff0e2","855":"4f4db5e6","962":"e6702ade"}[chunkId] + ".js";
};